var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h3',{staticClass:"purple darken-3 white--text rounded text-center py-3 mb-4"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }